import { FaqCategoryItem } from "../../types";

import { LOGIN_LOCATION_FAQ } from "./LoginLocationFaq";
import { INITIAL_LOGIN_INVITATION_EMAIL_FAQ } from "./InitialLoginInvitationEmailFaq";
import { TEACHER_PASSWORD_FORGOTTEN_FAQ } from "./TeacherPasswordForgottenFaq";
import { EXPIRED_INVITATION_LINK_FAQ } from "./ExpiredInvitationLinkFaq";
import { GOOGLE_MICROSOFT_ACCOUNT_LINKING_FAQ } from "./GoogleMicrosoftAccountLinkingFaq";
import { STUDENT_LOGIN_FAQ } from "./StudentLoginFaq";
import { STUDENT_LOGIN_CREDENTIALS_FAQ } from "./StudentLoginCredentialsFaq";

export const LOGIN_ITEMS: FaqCategoryItem[] = [
  LOGIN_LOCATION_FAQ,
  INITIAL_LOGIN_INVITATION_EMAIL_FAQ,
  EXPIRED_INVITATION_LINK_FAQ,
  TEACHER_PASSWORD_FORGOTTEN_FAQ,
  STUDENT_LOGIN_FAQ,
  STUDENT_LOGIN_CREDENTIALS_FAQ,
  GOOGLE_MICROSOFT_ACCOUNT_LINKING_FAQ,
];
